import React from "react";
import { StyleSheet, View, StyleProp, ViewStyle } from "react-native";

export type ChevronRightIconProps = {
  style?: StyleProp<ViewStyle>;
};

export const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({
  style,
}) => {
  return (
    <View style={[styles.container, style]}>
      <svg width="5.972" height="10" viewBox="0 0 5.972 10">
        <path
          d="M673.227,1210.877a.887.887,0,0,1,.629.26l4.193,4.193a.889.889,0,0,1,0,1.258l-4.028,4.028a.889.889,0,1,1-1.258-1.257l3.4-3.4-3.564-3.564a.889.889,0,0,1,.629-1.518Z"
          transform="translate(-672.338 -1210.877)"
          fill="#a5a5a5"
        />
      </svg>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
});
